import { IMapMngr } from '../interfaces';
import { AppConfig } from '../../app.config';

export class MapEventsTool extends NeWMI.Tool.Base.ATool {

  private callback: (geometry: any) => any;
  private cursor: string;

  constructor(protected mapMngr: IMapMngr) {
    super();
    this.id = MapEventsTool.ID;
  }

  setCallback(callback: (evt: NeWMI.Map.Events.MouseEvents) => any, eventsNeeded: NeWMI.Map.Enums.EMapEvents[]) {
    this.eventsNeeded = eventsNeeded;
    this.callback = callback;
  }

  setCursor(cursor: string) {
    this.cursor = cursor;
  }

  protected onMapEvent(evt): void {
    this.callback.call(this, evt);
  }

  activate(oldTool?: NeWMI.Tool.Base.ATool): boolean {
    if (this.cursor)
      this.mapMngr.setCursor(this.cursor);
    if (AppConfig.settings.map.esri && this.eventsNeeded.indexOf(NeWMI.Map.Enums.EMapEvents.MouseDrag) >= 0)
      this.map.setNavigationMode({ pan: false }); // newmi-tbd
    return super.activate(oldTool);
  }

  static get ID() {
    return "Tool_EURON_MapEventsTool";
  }

}
